module.exports = __webpack_public_path__ + "static/media/Lindsey_Teske.73bf92de.webp";